/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const scrolled = 'is-scrolled';

	const headerAddClass = () => {
		const header = document.querySelector('.header');
		const mainVis = document.querySelector('.top-mainVis');
		
		if (!header || !mainVis) return;
		
		const handleScroll = () => {
			const mainVisHeight = mainVis.offsetHeight;
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			
			// メインビジュアルの高さ分スクロールしたタイミングでis-scrolledクラスを追加/削除
			if (scrollTop >= mainVisHeight) {
				header.classList.add(scrolled);
			} else {
				header.classList.remove(scrolled);
			}
		};
		
		// スクロールイベントリスナーを追加
		window.addEventListener('scroll', handleScroll);
		
		// 初期状態をチェック
		handleScroll();
	};

	const mainVisSwiper = () => {
		const carousel = document.querySelector('.top-mainVis.splide');
		if (!carousel) return;
		
		const splide = new Splide(carousel, {
			type: 'fade',
			rewind: true,
			autoplay: true,
			interval: 6300,
			pauseOnHover: false,
			speed: 1000,
			arrows: false,
			pagination: true,
			paginationKeyboard: true,
		});

		splide.mount();
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		headerAddClass();
		mainVisSwiper();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
